var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCrossCircleFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11M7.833 7.833a1.03 1.03 0 0 1 1.459 0L12 10.542l2.708-2.709a1.031 1.031 0 1 1 1.459 1.459L13.458 12l2.709 2.708a1.031 1.031 0 0 1-1.459 1.459L12 13.458l-2.708 2.709a1.031 1.031 0 0 1-1.459-1.459L10.542 12 7.833 9.292a1.03 1.03 0 0 1 0-1.459",
  clipRule: "evenodd"
})));
export default SvgCrossCircleFill;